import React, {Fragment} from "react";
import {formatDateTime, formatPatientName} from "../../../helpers/FormatHelper";
import {Record} from '../../../models/Record';
import {StudyIcon, StudyType} from "../StudyIcon/StudyIcon";
import {useTranslation} from "react-i18next";
import {useLongPress} from "../../../hooks";

interface RecordProps {
    record: Record;
    onClick: () => void;
    onStudyClick: (type: StudyType) => void;
    onContextMenu?: (anchorX: number, anchorY: number) => void;
    onStudyContextMenu?: (type: StudyType, anchorX: number, anchorY: number) => void;
    compact?: boolean;
}

export const RecordsShort: React.FC<RecordProps> = ({record, onClick, onStudyClick, onContextMenu, onStudyContextMenu, compact = false}: RecordProps) => {
    const {t} = useTranslation();
    const contextMenuHandler = (event: React.MouseEvent<HTMLTableRowElement>) => {
        if (!onContextMenu) {
            return;
        }
        event.preventDefault();
        onContextMenu(event.clientX, event.clientY);
    };
    // touch: long press opens the context menu (iOS does not fire contextmenu)
    const longPress = useLongPress(onContextMenu);
    return (
        <tr onClick={onClick} onContextMenu={onContextMenu ? contextMenuHandler : undefined} {...longPress}>
            {compact ?
                <td className="text-left list-cell-wrap">
                    {formatPatientName(t, record.patientId === null, record.patientName)}
                    <div className="list-cell-subtitle">{formatDateTime(record.dateTime)}</div>
                </td> :
                <Fragment>
                    <td style={{whiteSpace: "normal"}}>{formatPatientName(t, record.patientId === null, record.patientName)}</td>
                    <td align="center" width="200px" style={{whiteSpace: "normal"}}>
                        <div style={{minWidth: "120x"}}>
                            {formatDateTime(record.dateTime)}
                        </div>
                    </td>
                </Fragment>
            }
            <td width="200" align="center">
                <div className="d-flex flex-row align-items-center justify-content-between">
                    <div className="d-flex align-items-center justify-content-center">
                        <StudyIcon type={StudyType.State} isVisible={record.state !== null} onClick={() => onStudyClick(StudyType.State)}
                                   onContextMenu={onStudyContextMenu ? (x, y) => onStudyContextMenu(StudyType.State, x, y) : undefined}/>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                        <StudyIcon type={StudyType.Ecg} isVisible={record.ecgStudy !== null} onClick={() => onStudyClick(StudyType.Ecg)}
                                   onContextMenu={onStudyContextMenu ? (x, y) => onStudyContextMenu(StudyType.Ecg, x, y) : undefined}/>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                        <StudyIcon type={StudyType.Spiro} isVisible={record.spiroStudy !== null} onClick={() => onStudyClick(StudyType.Spiro)}
                                   onContextMenu={onStudyContextMenu ? (x, y) => onStudyContextMenu(StudyType.Spiro, x, y) : undefined}/>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                        <StudyIcon type={StudyType.Stethoscope} isVisible={record.stethoscopeStudy !== null} onClick={() => onStudyClick(StudyType.Stethoscope)}
                                   onContextMenu={onStudyContextMenu ? (x, y) => onStudyContextMenu(StudyType.Stethoscope, x, y) : undefined}/>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                        <StudyIcon type={StudyType.LtEcg} isVisible={record.ltEcgStudy !== null} onClick={() => onStudyClick(StudyType.LtEcg)}
                                   onContextMenu={onStudyContextMenu ? (x, y) => onStudyContextMenu(StudyType.LtEcg, x, y) : undefined}/>
                    </div>
                </div>
            </td>
        </tr>
    );
}